// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1MDoD","badges":"styles_badges__1uTAG"};